import React, { useRef, useState, useEffect } from 'react';
import { Wrapper } from './style';
const AudioPlayer = ({ src = '', autoPlay = false }) => {
    const audioRef = useRef(null);
    const [volume, setVolume] = useState(1);
    const [seek, setSeek] = useState(5);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [hasStarted, setHasStarted] = useState(false);

    useEffect(() => {
        const audio = audioRef.current;

        const updateTime = () => {
            setCurrentTime(audio.currentTime);
            setDuration(audio.duration || 0);
        };

        const handlePlay = () => {
            setIsPlaying(true);
            setHasStarted(true);
        };
        const handlePause = () => setIsPlaying(false);

        audio.addEventListener('timeupdate', updateTime);
        audio.addEventListener('loadedmetadata', updateTime);
        audio.addEventListener('play', handlePlay);
        audio.addEventListener('pause', handlePause);

        return () => {
            audio.removeEventListener('timeupdate', updateTime);
            audio.removeEventListener('loadedmetadata', updateTime);
            audio.removeEventListener('play', handlePlay);
            audio.removeEventListener('pause', handlePause);
        };
    }, []);

    const togglePlayPause = () => {
        const audio = audioRef.current;
        if (isPlaying) {
            audio.pause();
        } else {
            audio.play();
        }
    };

    const stop = () => {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        setHasStarted(false);
        setIsPlaying(false);
    };

    const changeVolume = (e) => {
        const newVolume = parseFloat(e.target.value);
        setVolume(newVolume);
        audioRef.current.volume = newVolume;
    };

    const forward = () => audioRef.current.currentTime += seek;
    const rewind = () => audioRef.current.currentTime -= seek;

    const formatTime = (time) => {
        if (isNaN(time)) return '00:00';
        const minutes = Math.floor(time / 60).toString().padStart(2, '0');
        const seconds = Math.floor(time % 60).toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    return (
        <Wrapper>
            <audio ref={audioRef} src={src} autoPlay={autoPlay} />


            <button onClick={togglePlayPause}>{isPlaying ? '⏸' : '▶'}</button>

            {hasStarted ? (
                <button onClick={stop}>⏹</button>
            ) : (
                <span>Dinle</span>
            )}

            {/* <div style={{ marginBottom: 10 }}>
        <label>🔊 Ses: {Math.round(volume * 100)}%</label><br />
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={changeVolume}
          style={{ width: '100%' }}
        />
      </div> */}

            {/* <div style={{ marginBottom: 10 }}>
        <label>⏩ Sarma süresi (sn):</label>
        <input
          type="number"
          value={seek}
          onChange={(e) => setSeek(Number(e.target.value))}
          style={{ width: 50, marginLeft: 8 }}
        />
        <button onClick={rewind}>⏪</button>
        <button onClick={forward}>⏩</button>
      </div> */}

            <div>
                Süre: {formatTime(currentTime)} / {formatTime(duration)}
            </div>
        </Wrapper>
    );
};

export default AudioPlayer;